import AuthController from '../domain/controller.js'
import saveUserInLocalData from './saveUserInLocalData.js'
import makeLogout from './makeLogout.js'
import { fetchRolePermissions } from './fetchRolePermissions.js'

async function refreshUserData(context) {
  const { networkRepo } = context

  try {
    const updatedUser = await AuthController.getProfile(networkRepo)

    if (!updatedUser) {
      console.warn('User not found in database, logging out...')
      return await makeLogout(context, { reason: 'user_not_found' })
    }

    const isAdmin = updatedUser.role === 'admin' || updatedUser.role === 'super-admin' || updatedUser.isSuperAdmin === true
    if (!isAdmin) {
      console.warn('User is not an admin, logging out...')
      return await makeLogout(context, { reason: 'not_admin' })
    }

    // Re-fetch role permissions to keep them up to date
    await fetchRolePermissions(updatedUser)

    // Update local data with fresh info
    await saveUserInLocalData(context, updatedUser)
    return updatedUser
  } catch (error) {
    const err = /** @type {any} */ (error)
    if (err.statusCode === 401 || err.statusCode === 404) {
      console.warn('Session invalid or user not found, logging out...')
      return await makeLogout(context, { reason: 'session_invalid' })
    }
    // For other errors (network etc.), we might want to keep the local data
    console.error('Failed to refresh user data:', error)
    throw error
  }
}

export default refreshUserData
